import { useFormReadiness } from '../forms/ValidatedForm';

export default function LessonAutosaveStatus({ autosave, blocked = false }) {
  const { valid } = useFormReadiness();
  return <div className="lesson-autosave">
    {autosave.error ? <>
      <p className="lesson-error" role="alert">Changes weren’t saved. {autosave.error}</p>
      {!blocked && <button type="button" disabled={!valid || autosave.saving} onClick={() => autosave.save(true)}>Retry saving</button>}
    </> : <p className="lesson-hint" role="status">{autosave.saving ? 'Saving…' : autosave.dirty
      ? blocked ? 'Changes not saved. Review the latest version.' : !valid ? 'Changes not saved. Complete or correct the fields below.' : 'Waiting to save…'
      : autosave.savedOnce ? 'All changes saved.' : 'Changes save automatically.'}</p>}
  </div>;
}
